import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableF12Key]'
})
export class DisableF12KeyDirective {

  constructor() { }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 123) { // F12 key code
      event.preventDefault();
    }

    if (event.ctrlKey && event.keyCode === 85) { // Ctrl + U (85 is the key code for 'U')
      event.preventDefault();
    }

    if (event.ctrlKey && event.shiftKey && event.keyCode === 73) { // Ctrl + Shift + I (73 is the key code for 'I')
      event.preventDefault();
    }
  }
}
